import { useCompanyHasFeature } from 'hooks/useCompanyHasFeature'
import { useUserHasFeature } from 'hooks/useUserHasFeature'
import { useSelector } from 'react-redux'
import { isModelLoadingSelector as userRolesLoadingSelector } from 'services/auth/slice'
import { isModelLoadingSelector as companyFeaturesLoadingSelector } from 'services/channelSettings/slice'

export const useHasFeature = flag => {
  const companyHasFeature = useCompanyHasFeature(flag)
  const userHasFeature = useUserHasFeature(flag)
  const companyFeaturesLoading = useSelector(companyFeaturesLoadingSelector)
  const userRolesLoading = useSelector(userRolesLoadingSelector)

  if (!userRolesLoading && !companyFeaturesLoading) {
    if (flag && (!companyHasFeature || !userHasFeature)) {
      return false
    }
  }
  return true
}
